import { z } from "zod";

const LessonProgressSchema = z.object({
  id: z.string(),
  title: z.string(),
  status: z.enum(["not_started", "in_progress", "completed"]),
  percentComplete: z.number().min(0).max(100),
  completedAt: z.string().nullable(),
  lastActivityAt: z.string().nullable(),
  accessible: z.boolean(),
});

export const LearnerProgressSchema = z.object({
  userId: z.string(),
  tracks: z.array(
    z.object({
      id: z.string(),
      kind: z.enum(["program", "course"]),
      name: z.string(),
      totalLessons: z.number().int().nonnegative(),
      completedLessons: z.number().int().nonnegative(),
      percentComplete: z.number().min(0).max(100),
      lastActivityAt: z.string().nullable(),
      access: z.enum(["available", "partial", "unavailable"]),
      lessons: z.array(LessonProgressSchema),
    }),
  ),
});

export type LearnerProgress = z.infer<typeof LearnerProgressSchema>;
